export default "__VITE_ASSET__Ck99_pBM__"